<template>
  <v-container class="max-width-700 bg-white">
      <v-form id="custom-form" action="/" class="row" v-model="valid" ref="form" method="POST" name="beraten-lassen-formular-unternehmensverkauf" @submit.prevent="sendToNetlify">
        <v-col
          cols="12"
          md="6"
        >
          <input type="hidden" name="form-name" value="beraten-lassen-formular-unternehmensverkauf" />
            <v-text-field
              v-model="vornachname"
              name="vornachname"
              :rules="nameRules"
              required
              class="custom-lable"
            >
              <template v-slot:label>
                <span class="input__label">
                  Ihr Name
                </span>
              </template>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="email"
              :rules="emailRules"
              name="email"
              required
            >
              <template v-slot:label>
                <span class="input__label">
                  Ihre E-Mail
                </span>
              </template>
            </v-text-field>
          </v-col>
        <v-row>
          <v-col
            cols="12"
          >
            <v-checkbox
              required
              v-model="checkbox"
              :rules="checkboxRules"
              :rippe=false
              name="datenschutz"
            >
              <template v-slot:label>
                <span class="datenschutz-label">
                  Ich habe die <a href="https://raab-coaching.de/datenschutz">Datenschutzerklärung</a> gelesen, und erkläre mich damit einverstanden, per E-Mail von Ihnen Kontaktiert zu werden.
                </span>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
          >
            <button type="submit" class="btn"
              >
                <div class="img">
                  <img src="/images/pfeil_rechts.svg" />
                </div>
                <div class="text">
                  Jetzt unverbindliche Beratung Anfordern!
                </div>
              </button>

          </v-col>
        </v-row>
      </v-form>
    <v-row>
      <v-col id="form-success">
        <h1>Vielen Dank für Ihre unverbindliche Anfrage.</h1>
        <p>Ich werde Sie zeitnah kontaktieren und freue mich, Ihnen weiterhelfen zu können.</p>
      </v-col>

      <v-col id="form-fail">
        <h1>Sorry, da ging was schief</h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
  .max-width-700 {
    max-width: 700px;

    &.bg-white {
      background-color: white;
    }
  }

  .datenschutz-label {
    color: #8288A3;
    font-style: italic;

    a {
      color: #8288A3;
      text-decoration: underline;
    }
  }

  #custom-form {
    display: flex;
    width: 100%;
  }

  #form-success,
  #form-fail {
    display: none;
  }

  #form-success {
    flex-direction: column;
    padding: 0;

    h1 {
      font-size: 1.667rem;
      color: #192F97;
      margin-left: 0;
      margin-bottom: 1rem;
    }

    p {
      font-weight: bold;
      color: #192F97;
    }
  }

  .input__label {
    color: #262F5C;
  }

  .btn {
    display: flex;
    max-width: 353px;
    width: 100%;
    border: 3px solid #FFFFFF;
    border-radius: 36px;
    background-color: #f49e00;
    box-shadow: 0 5px 5px #00000029;
    padding: 13px 41px 13px 20px;
    margin: 0 auto;

    &:hover {
      cursor: pointer;
    }

    .img {
      display: flex;
    }

    .text {
      text-align: center;
      text-transform: uppercase;
      color: white;
      text-shadow: 0 3px 6px #00000029;
      font-weight: bold;
      letter-spacing: .4px;
      line-height: 1.222rem;
      font-size: 1.111rem;
      padding-left: 10px;
    }
  }

  @media screen and (max-width: 360px) {
    .btn {
      flex-direction: column-reverse;
      padding: 13px 20px;

      .text {
        font-size: 1rem;
        padding-left: 0;
      }

      img {
        margin: 1rem auto 0 auto;
      }
    }
  }
</style>

<script>
const axios = require('axios')

export default {
  data: () => ({
    valid: false,
    email: '',
    vornachname: '',
    checkbox: '',
    emailRules: [
      v => !!v || 'Bitte eine E-Mail-Adresse angeben.,',
      v => /.+@.+/.test(v) || 'Bitte eine gültige E-Mail-Adresse angeben.'
    ],
    nameRules: [
      v => !!v || 'Bitte geben Sie Ihren Name an.'
    ],
    checkboxRules: [
      v => !!v || 'Bitte Stimmen Sie zu.'
    ]
  }),
  methods: {
    sendToNetlify: function (e) {
      this.$refs.form.validate()
      if (this.valid) {
        var formData = 'form-name=beraten-lassen-formular-unternehmensverkauf&email=' + this.email + '&vornachname=' + this.vornachname + '&datenschutz=' + this.checkbox
        axios.post(document.getElementById('custom-form').getAttribute('action'), formData)
          .then(response => {
            document.getElementById('custom-form').classList.add('d-none')
            if (response.status === 200) {
              document.getElementById('form-success').classList.add('d-flex')
            } else {
              document.getElementById('form-faile').classList.add('d-flex')
            }
          })
      }
    }
  }
}

</script>
